// Absolute URL for an account's `symbolDisplayPath`, or undefined when there
// is nothing this app can load. The API falls back to a generated monogram
// (`/monogram/:initials`), which pop-core serves only on its app.* host — on
// the API host it is a 404 — so callers show their own fallback instead.
export default (path?: string | null): string | undefined => {
  if (!path || path.startsWith("/monogram/")) return undefined;

  return `${process.env.REACT_APP_API_URL}${path}`;
};
